module.exports = __webpack_public_path__ + "static/img/35b6772ade8e87e12c2e1f1f4f98d56.3f6fe8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/money_tree/35b6772ade8e87e12c2e1f1f4f98d56.png
// module id = QA87
// module chunks = 16